/* Service names */
export const CreateUnauthenticatedAppointmentServiceName =
  'create-unauthenticated-appointment';
  export const CreateUnauthenticatedAppointmentByMHNServiceName =
  'create-unauthenticated-appointment-by-patient-mhn';
export const GetAcceptFormatQuestionsServiceName =
  'get-accept-format-questions';
export const GetPulseServiceName = 'pulse';
export const GetUnauthenticatedAppointmentSlotsServiceName =
  'get-unauthenticated-appointment-slots';
export const GetUnauthenticatedProviderAppointmentTypesServiceName =
  'get-unauthenticated-provider-appointment-types';
export const RecaptchaSiteVerifyServiceName = 'verify';
export const SendPatientAccessCodeServiceName = 'send-patient-access-code';
export const VerifyByMHNAndDateOfBirthServiceName =
  'verify-by-patient-mhn-and-date-of-birth';
export const VerifyPatientAccessCodeServiceName = 'verify-patient-access-code';
